<template>
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M26.8389 23.748V6.24805C26.8389 3.74805 25.5889 2.49805 23.0889 2.49805H18.0889C15.5889 2.49805 14.3389 3.74805 14.3389 6.24805V23.748C14.3389 26.248 15.5889 27.498 18.0889 27.498H23.0889C25.5889 27.498 26.8389 26.248 26.8389 23.748Z" stroke="#2C2738" stroke-width="2" stroke-linecap="round"/>
    <path d="M14.3389 7.5H20.5889" stroke="#2C2738" stroke-width="2" stroke-linecap="round"/>
    <path d="M14.3389 22.5H19.3389" stroke="#2C2738" stroke-width="2" stroke-linecap="round"/>
    <path d="M14.3389 17.4336L20.5889 17.4961" stroke="#2C2738" stroke-width="2" stroke-linecap="round"/>
    <path d="M14.3389 12.502H18.0889" stroke="#2C2738" stroke-width="2" stroke-linecap="round"/>
    <path d="M6.86309 2.49805C4.82559 2.49805 3.16309 4.16055 3.16309 6.18555V22.3855C3.16309 22.948 3.40059 23.798 3.68809 24.2855L4.71309 25.9855C5.88809 27.948 7.82559 27.948 9.00059 25.9855L10.0256 24.2855C10.3131 23.798 10.5506 22.948 10.5506 22.3855V6.18555C10.5506 4.16055 8.88809 2.49805 6.86309 2.49805Z" stroke="#2C2738" stroke-width="2" stroke-linecap="round"/>
    <path d="M10.5506 8.75195H3.16309" stroke="#2C2738" stroke-width="2" stroke-linecap="round"/>
  </svg>
</template>

<script>
import iconMixin from "@/services/iconMixins.js";

export default {
  mixins: [iconMixin]
};
</script>
